<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="qualityControl-box">
      <div class="center-box">
        <div class="qualityControl-box">
          <div class="crumbs">首页 > 质控课程 > 质控课程详情</div>
          <div class="details-box">
            <div class="video-box">
              <video ref="myVideo" id="myVideoId" v-if="newsContent.video != undefined" :src="newsContent.video.url" @timeupdate="videoTimeupdate" @seeking="checkSeek" controls="controls" />
            </div>
            <div class="details-text">
              <div class="details-title">{{ newsContent.title }}</div>
              <div class="details-label">
                <div class="label-li">
                  讲课人：{{ newsContent.author }}
                </div>
                <div class="label-li">
                  发布时间：{{ newsContent.createTimeFormat }}
                </div>
              </div>
              <div class="details-bt" v-if="token != ''">
                <div class="bt" @click="toggleFirst"><img :src="newsContent.like ? require('@/assets/images/f5.png') : require('@/assets/images/f1.png')" />{{ newsContent.likeCount }}</div>
                <div class="bt" @click="addCollect"><img :src="newsContent.collect ? require('@/assets/images/f6.png') : require('@/assets/images/f3.png')" />{{ newsContent.collectCount }}</div>
                <div class="bt" @click="onClickShare"><img src="@/assets/images/f4.png" />{{ newsContent.shareCount }}</div>
                <div class="bt" @click="showComment"><img src="@/assets/images/f2.png" />{{ newsContent.commentCount }}</div>
              </div>
            </div>
          </div>
          <div class="title-box">
            <div class="title">相关推荐</div>
          </div>
          <course v-if="newsContent.recommend != undefined" :courses="newsContent.recommend" :watchedList="watchedList" @gotoCourseDetails="gotoCourseDetails" />
          <empty class="empty-margin" v-if="newsContent.recommend.length <= 0"></empty>
          <comment :commentList="commentList" v-if="token != ''" />
          <el-pagination v-if="token != ''" class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total"
            @size-change="sizeChange" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
          </el-pagination>
          <commentInput :showCommentPop.sync="showCommentPop" :id="id"></commentInput>
        </div>
      </div>
    </div>

    <el-dialog title="请先完善信息" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>请先上传执业证和身份证信息，后台认证审核通过后的您才能查看浏览该板块</span>
      <span slot="footer" class="dialog-footer-info">
        <el-button type="primary" @click="onClickRoute">确 定</el-button>
      </span>
    </el-dialog>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import comment from "@/components/base/comment"
import commentInput from "@/components/base/commentInput"
import empty from "@/components/empty/index";
import { getPageDetails, informationPraise, informationCollect, informationShare } from '@/api/home'
import { getCommentList, getCurrentUser } from '@/api/user'
import { postStudyAdd, postStudyEdit } from '@/api/api'

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, comment, commentInput, empty },
  data() {
    return {
      selectedIndex: 1,
      courses: [
        { id: 1, title: "「博闻广术」第三篇：鼻科篇 | 周兵教授亲授！北京同仁医院名家执刀4台高清鼻科手术全回放！", time: "2024-01-01 20:00", imageUrl: require('@/assets/images/img.png') },
        { id: 2, title: "「博闻广术」第三篇：鼻科篇 | 周兵教授亲授！北京同仁医院名家执刀4台高清鼻科手术全回放！", time: "2024-01-01 20:00", imageUrl: require('@/assets/images/img.png') },
        { id: 3, title: "「博闻广术」第三篇：鼻科篇 | 周兵教授亲授！北京同仁医院名家执刀4台高清鼻科手术全回放！", time: "2024-01-01 20:00", imageUrl: require('@/assets/images/img.png') },
        { id: 4, title: "「博闻广术」第三篇：鼻科篇 | 周兵教授亲授！北京同仁医院名家执刀4台高清鼻科手术全回放！", time: "2024-01-01 20:00", imageUrl: require('@/assets/images/img.png') },
      ],
      watchedList: [2], // 示例已观看的课程 ID
      currentPage2: 5,
      name: '童超晖教授',
      time: '2024-01-01 20:00',
      title: '「博闻广术」第三篇：鼻科篇 | 周兵教授亲授！北京同仁医院名家执刀4台高清鼻科手术全回放！',
      id: '',
      newsContent: {
        recommend: [],
      },
      page: {
        number: 1,
        limit: 10,
        total: 0
      },
      commentList: [],
      token: '',
      showCommentPop: false,
      duration: 0,
      learningProgress: null,
      maxPlayTime: 120, // 2分钟
      isVip: false,
      dialogVisible: false,
      userInfo: {},
    }
  },
  watch: {
    '$route'(to, from) {
      location.reload()
    }
  },
  methods: {
    showComment() {
      this.showCommentPop = true
    },
    gotoNews() {
      this.$router.push('/NewsCenter')
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails() {
      getPageDetails({
        id: this.id
      }).then(res => {
        this.newsContent = res.data[0]
        if (res.data[0].isVip) {
          this.isVip = res.data[0].isVip
          this.maxPlayTime = res.data[0].notVerifiedWatchSeconds
        }
        if (this.newsContent.learningProgress) {
          this.learningProgress = this.newsContent.learningProgress
          this.duration = this.newsContent.learningProgress.duration
          this.$nextTick(() => {
            this.$refs.myVideo.currentTime = this.duration
          })
        } else {
          this.duration = 0
        }
      })
    },
    // 分页查询资讯评论
    getCommentList() {
      getCommentList({
        number: this.page.number,
        limit: this.page.limit,
        informationId: this.id,
        checkStatus: 'SUCCESS'
      }).then(res => {
        this.commentList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.limit = value
      this.page.number = 1
      this.getCommentList()
    },
    currentChange(value) {
      this.page.number = value
      this.getCommentList()
    },
    prevClick(value) {
      this.page.number = value
      this.getCommentList()
    },
    nextClick(value) {
      this.page.number = value
      this.getCommentList()
    },
    // 获取当前登录用户
    async getCurrentUser() {
      await getCurrentUser().then(res => {
        if(res.code == 'A00000') {
          localStorage.setItem("userInfo", JSON.stringify(res.data[0]))
          this.userInfo = res.data[0]
        }
      })
    },
    toggleFirst() {
      informationPraise({
        informationId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          // this.getPageDetails()
          this.newsContent.like = !this.newsContent.like
          if(this.newsContent.like) {
            this.newsContent.likeCount = ++this.newsContent.likeCount
          }else {
            this.newsContent.likeCount = --this.newsContent.likeCount
          }
        }
      })
    },
    onClickShare() {
      informationShare({
        informationId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          const url = window.location.href; // 获取当前页面的URL
          navigator.clipboard.writeText(url).then(() => {
            // 复制成功后的回调
            this.$message.success("已复制链接!")
            this.newsContent.shareCount = ++this.newsContent.shareCount
          }).catch(err => {
            // 复制失败的处理
            console.error('复制失败:', err);
          });
        }
      })
    },
    addCollect() {
      informationCollect({
        informationId: this.id
      }).then(res => {
        if (res.code == "A00000") {
          this.newsContent.collect = !this.newsContent.collect
          if(this.newsContent.collect) {
            this.newsContent.collectCount = ++this.newsContent.collectCount
          }else {
            this.newsContent.collectCount = --this.newsContent.collectCount
          }
        }
      })
    },
    videoTimeupdate(value) {
      const myVideo = this.$refs.myVideo;
      this.duration = Math.floor(myVideo.currentTime)
      if(this.token == "") {
        myVideo.pause();
        this.$router.push({ path: `/login` });
        return
      }
      if (this.isVip && myVideo.currentTime > this.maxPlayTime && this.userInfo.doctor.authentication != 'A1') {
        myVideo.currentTime = this.maxPlayTime;
        myVideo.pause();
        this.dialogVisible = true
      }
    },
    checkSeek() {
      const myVideo = this.$refs.myVideo;
      if(this.token == "") {
        myVideo.pause();
        this.$router.push({ path: `/login` });
        return
      }
      if (this.isVip && myVideo.currentTime > this.maxPlayTime && this.userInfo.doctor.authentication != 'A1') {
        myVideo.currentTime = this.maxPlayTime;
        myVideo.pause();
        this.dialogVisible = true
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 确定跳转完善信息详情
    onClickRoute() {
      this.$router.push({ path: `/PersonalCenter?activeIndex=5` });
      this.dialogVisible = false
    },
    addStudy() {
      postStudyAdd({
        informationId: this.id,
        duration: this.duration
      }).then(res => {
        if (res.code == "A00000") {
          // this.$message.success("已加入学习计划!")
        }
      })
    },
    editStudy() {
      postStudyEdit({
        dv: this.learningProgress.dv,
        duration: this.duration
      }).then(res => {
        if (res.code == "A00000") {
          // this.$message.success("已修改学习计划!")
        }
      })
    },
    setStudy() {
      if (this.duration > 0) {
        if (this.learningProgress) {
          // 修改视频进度
          this.editStudy()
        } else {
          // 添加视频进度
          this.addStudy()
        }
      }
    },
    gotoCourseDetails() {
      this.setStudy()
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.id = this.$route.params.id
    this.token = localStorage.getItem('x-token') ? localStorage.getItem('x-token') : ''
    this.getPageDetails()
    if (this.token != "") {
      this.getCommentList()
    }
    this.getCurrentUser()
  },
  destroyed() {
    this.setStudy()
  },
}
</script>

<style lang="less" scoped>
.empty-margin {
  padding: 40px 0;
}

/deep/.qualityControl-box .course-li {
  margin-top: 26px;
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}

.title-box {
  margin-bottom: 0;
}

.details-box {
  display: flex;
  background: #fff;
  margin-top: 18px;
  margin-bottom: 50px;

  .details-text {
    width: calc(100% - 830px);
    text-align: left;
    padding: 20px;
    position: relative;

    .details-bt {
      display: flex;
      align-items: center;
      bottom: 20px;
      right: 20px;
      position: absolute;

      .bt {
        color: #999999;
        font-size: 16px;
        line-height: 38px;
        width: 80px;
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-left: 14px;
        justify-content: center;
        border: 1px solid #999999;
        border-radius: 4px;
        img {
          width: 14px;
          margin-right: 6px;
        }
      }
    }

    .details-label {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 14px;
      gap: 8px;

      .label-li {
        background: rgba(189, 24, 30, 0.1);
        height: 30px;
        line-height: 30px;
        color: rgba(189, 24, 30, 1);
        font-size: 14px;
        font-weight: normal;
        padding: 0 10px;
        margin-right: 4px;
        border-radius: 4px;
      }
    }

    .details-title {
      color: #222222;
      font-size: 20px;
      line-height: 30px;
      font-weight: bold;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  video {
    width: 830px;
    height: 469px;
  }

  .video-box {
    width: 830px;
    height: 469px;
  }
}

.center-box {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseDetails/index.vue